import React from 'react'
import Modal from 'react-responsive-modal';
import Strings from '../../translations/translations';
import InsButton from '../InsButton/InsButton';




const ModalError = ({ 
  title = Strings('email_send'),
  text = Strings('email_send'),
  btnText = Strings('email_send'),
  ...rest
}) => {
  return (
    <Modal center {...rest}>
      <h2 className="modal-title">{title}</h2>
      <div className="modal-content">{text}</div>
        <InsButton 
          text={btnText}
          onClick={rest.onClose}
        />
    </Modal>
  )
};

export default ModalError